import { yupResolver } from "@hookform/resolvers/yup";
import { UploadIcon, CheckCircledIcon } from "@radix-ui/react-icons";
import { Heading, Flex, Card, Button, Text } from "@radix-ui/themes";
import { Controller, useForm } from "react-hook-form";
import { UploadImagesFormValidation } from "./UploadImagesFormValidation";
import { DragAndDropFileUpload } from "../../components/inputs/FileUpload/DragAndDropFileUpload";
import { postFormData } from "../../utils/axios-config";
import { UPLOAD_IMAGES } from "../../utils/constants";
import toast from "react-hot-toast";

export type FileType = "favicon" | "logo" | "background";

interface UploadItemType {
  type: FileType;
  acceptedFormats?: string;
  file: File;
  preview?: string;
  uploaded?: boolean;
}
interface UploadItem {
  type: FileType;
}

export const UploadItem = ({ type = "logo" }: UploadItem) => {
  const {
    handleSubmit,
    control,
    formState: { errors },
    reset,
    getValues,
    setValue,
    watch,
  } = useForm<UploadItemType>({
    resolver: yupResolver(UploadImagesFormValidation),
    defaultValues: {
      type: type,
    },
    mode: "onChange",
    reValidateMode: "onChange",
    shouldUseNativeValidation: false,
  });

  const handleFileSelect = (file?: File) => {
    if (!file) return;
    const reader = new FileReader();
    reader.onloadend = () => {
      setValue("preview", reader.result as string);
    };
    reader.readAsDataURL(file);
  };
  const preview = watch("preview");
  //  const title = watch("title");
  console.log({ errors });
  const onSubmit = handleSubmit(async (data) => {
    try {
      const formData = new FormData();
      formData.append("file", data.file);
      formData.append("fileType", data.type);
      await postFormData(UPLOAD_IMAGES, formData);
      setValue("uploaded", true);
      toast.success("Imagem carregada ");
    } catch (error) {
      toast.error("Erro");
    }
  });

  return (
    <form onSubmit={onSubmit} noValidate>
      <Flex direction="column" gap="4"  >
        <Card
          style={{
            padding: "20px",
            marginBottom: "10px",
            borderBottom: "10px",
          }}
        >
          <Flex direction="row" gap="4" align="start">
            <div
              style={{
                width: "150px",
                height: "150px",
                border: "5px dashed #ccc",
                borderRadius: "8px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                overflow: "hidden",
                backgroundColor: "#f9f9f9",
              }}
            >
              {preview ? (
                <img
                  src={preview}
                  alt={"Image"}
                  style={{
                    maxWidth: "100%",
                    maxHeight: "100%",
                    objectFit: "contain",
                  }}
                />
              ) : (
                <UploadIcon width="40" height="40" color="#ccc" />
              )}
            </div>

            <Flex direction="column" gap="2" style={{ flex: 1 }}>
              <Heading
                size="4"
                style={{
                  fontSize: "18px",
                  fontWeight: "600",
                  color: "#333",
                  textTransform: "capitalize",
                 
                }}
              >
                {type}
              </Heading>
              <Flex gap="2" mt="2">
                <Controller
                  name="file"
                  control={control}
                  render={({ field }) => (
                    <DragAndDropFileUpload
                      onFileDrop={(file) => {
                        field.onChange(file);
                        handleFileSelect(file!);
                      }}
                      label="Arraste ou selecione o ficheiro"
                      selectedFile={field.value}
                    />
                  )}
                />
                {errors.file && (
                  <Text color="red" size="1">{`${errors.file?.message}`}</Text>
                )}
                <Button
                  type="submit"
                  disabled={watch("uploaded")}
                  color="green"
                >
                  {watch("uploaded") ? (
                    <>
                      <CheckCircledIcon /> Enviado
                    </>
                  ) : (
                    "Carregar Ficheiro"
                  )}
                </Button>
              </Flex>
            </Flex>
          </Flex>
        </Card>
      </Flex>
    </form>
  );
};
